<template>
    <span v-bind:class="{'text-error' : !value && highlightIfMissing}">
        <template v-if="!value">
            Not supplied
        </template>
        <template v-else>
            {{value}}
        </template>
    </span>
</template>

<script>
    export default {
        name: 'FieldWithNotSuppliedFallback',
        props: {
            value: String,
            highlightIfMissing: Boolean
        }
    }
</script>